import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import { useAppServices } from 'hook/services'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDButton from 'components/MDButton'
import Editor from 'components/editor'

function AppProfiles({ data, handleChange }) {
  const Service = useAppServices()
  const { id } = useParams()
  const [image, setImage] = useState(null)
  const [previewUrl, setPreviewUrl] = useState(data?.app_profile)
  const [videoUrl, setVideoUrl] = useState(data?.preview_video || '')
  const [description, setDescription] = useState(data?.app_description || '')
  const [errors, setErrors] = useState({
    previewImage: '',
    previewVideoUrl: ''
  })
  const handleImageUpload = (e) => {
    const file = e.target.files[0]
    if (file) {
      setImage(file)
      setPreviewUrl(URL.createObjectURL(file))
      setErrors(prev => ({ ...prev, previewImage: '' }))
    }
  }

  const handleVideoUrlChange = (e) => {
    const url = e.target.value
    setVideoUrl(url)
    const isValid = url === '' || /^https:\/\/(www\.)?youtube\.com\/watch\?v=/.test(url)
    setErrors(prev => ({
      ...prev,
      previewVideoUrl: isValid ? '' : 'Enter a valid YouTube URL (https://youtube.com/watch?v=...)'
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    let imageUrl = data?.preview_image
    if (image) {
      const form = new FormData()
      form.append('image', image, image.name)
      const desiredPath = `design/${id}/preview`
      const { response } = await Service.utils.upload_image({
        toaster: false,
        payload: form,
        query: `desiredPath=${desiredPath}`,
      })
      console.log("response", response)

      if (response?.data) {
        imageUrl = response.data
      } else {
        setErrors(prev => ({ ...prev, previewImage: 'Image upload failed' }))
        return
      }
    }
    const payload = {
      _id: id,
      app_profile: imageUrl,
      preview_video: videoUrl,
      app_description: description,
    }

    const { response } = await Service.snapshot_onboarding.update({ payload })
    if (response) handleChange()
  }

  return (
    <Card id="app-profiles" key={data?._id}>
      <MDBox p={3}>
        <MDTypography variant="h5">App Profiles</MDTypography>
      </MDBox>

      <MDBox component="form" onSubmit={handleSubmit} pb={3} px={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <MDTypography variant="subtitle2" display="block" gutterBottom>
              App Description
            </MDTypography>
            <Editor handleChange={(val) => setDescription(val)} data={description} />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle2" gutterBottom>
              Upload preview image for your application <span style={{ color: 'red' }}>*</span>
            </Typography>
            <Box
              sx={{
                border: '1px dashed #ccc',
                padding: 2,
                textAlign: 'center',
                borderRadius: 2,
                background: '#fafafa',
              }}
            >
              <input
                type="file"
                accept="image/png, image/jpeg, image/jpg, image/gif, image/svg"
                onChange={handleImageUpload}
                style={{ display: 'none' }}
                id="upload-image"
              />
              <label htmlFor="upload-image" style={{ cursor: 'pointer' }}>
                <Typography color="primary">Click to upload</Typography>
                <Typography variant="body2">
                  PNG, JPG, SVG, GIF (Min: 640×360px, Max: 960×540px)
                </Typography>
              </label>
              {previewUrl && (
                <Box mt={2}>
                  <img
                    src={previewUrl}
                    alt="Preview"
                    style={{ maxWidth: '100%', maxHeight: '300px', borderRadius: '8px' }}
                  />
                </Box>
              )}
            </Box>
            {errors.previewImage && (
              <Typography color="error" variant="caption">
                {errors.previewImage}
              </Typography>
            )}
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="App preview video (YouTube URL)"
              value={videoUrl}
              onChange={handleVideoUrlChange}
              error={!!errors.previewVideoUrl}
              helperText={errors.previewVideoUrl}
            />
          </Grid>
        </Grid>

        <MDBox display="flex" justifyContent="flex-end" mt={3}>
          <MDButton variant="gradient" color="dark" type="submit">
            Update
          </MDButton>
        </MDBox>
      </MDBox>
    </Card>
  )
}

export default AppProfiles
